export const priceRegEx = /^$|^([0.]|[1-9]\d{0,7})(?:\.\d{0,2})?$/;
export const specSymbolRegEx = /[#$@!%&*+-_0-9]/;
export const letterRegEx = /[a-zA-Z]/;

export default priceRegEx;
